module.exports = __webpack_public_path__ + "img/drop-up.03520edb.svg";